<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Edit Youtube Music</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home >
            </router-link>
            <router-link :to="`/blogs`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Youtube Music >
            </router-link>
            <a class="breadcrumb-item" href="#">Edit Youtube Music</a>
          </nav>
        </div>
      </div>
      <YoutubeForm :blog="null" :isEdit="true"></YoutubeForm>
    </div>
  </div>
</template>

<script>
import YoutubeForm from '@/components/YoutubeForm'
/* eslint-disable no-undef */
export default {
  name: 'EditYoutubeForm',
  components: {
    YoutubeForm
  },
  data () {
    return {}
  },
  mounted () {
    $('.thumbnail-display').click(function () {
      $('#thumbnail').click()
    })

    $('#thumbnail').on('change', function (event) {
      var elem = $(this)
      var reader = new FileReader()
      var image = ''
      reader.readAsDataURL(event.target.files[0])
      reader.onload = function () {
        image = reader.result
        elem.attr('data-img', image)
        $('.thumbnail-display').css('background-image', 'url(' + image + ')')
      }
    })
  },
  methods: {}
}
</script>

<style scoped>
.thumbnail-display {
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Youtube/EditYoutubeMusic.vue